import { FC, useState } from "react";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { postContactUsBusiness } from "services/api";
import Seo from "components/Seo/Seo";

export interface PageContactProps {
  className?: string;
}

const PageContactBusiness: FC<PageContactProps> = ({ className = "" }) => {
  const [form, setForm] = useState<any>({
    fullName: "",
    industry: "",
    titleOfMessage: "",
    companyName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleChange = (event: any) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const onClick = () => {
    setLoading(true);
    postContactUsBusiness(form)
      .then((res) => {
        setLoading(false);
        setSent(true);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error sending contact form:", error);
      });
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Seo
        name="Contact Us | Orbito Travel"
        description="Connect with Orbito Travel for personalized assistance and inquiries. Reach out to our team for support with accessible travel arrangements. Start your journey towards inclusive exploration by contacting us today!"
        title="Contact Us | Orbito Travel"
        type="page"
      />
      <div className="mb-24 lg:mb-32">
        <h2 className="my-16 sm:my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          B2B Contact Form
        </h2>
        <div className="container max-w-7xl mx-auto">
          <div className="flex-shrink-0">
            {sent ? (
              <div className="text-lg font-medium text-green-600">
                We have received your message. Thank you!
              </div>
            ) : (
              <form
                className="grid grid-cols-1 sm:grid-cols-2 gap-6"
                action="#"
                method="post"
              >
                {/* Left Column */}
                <div className="space-y-6">
                  {/* Company Name */}
                  <label className="block">
                    <Label>Company Name</Label>
                    <Input
                      type="text"
                      className="mt-1"
                      name="companyName"
                      value={form.companyName}
                      onChange={handleChange}
                    />
                  </label>
                  {/* Full Name */}
                  <label className="block">
                    <Label>Full Name</Label>
                    <Input
                      type="text"
                      className="mt-1"
                      name="fullName"
                      value={form.fullName}
                      onChange={handleChange}
                    />
                  </label>
                  {/* Email */}
                  <label className="block">
                    <Label>Email</Label>
                    <Input
                      type="email"
                      className="mt-1"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </label>
                  {/* Phone Number */}
                  <label className="block">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      className="mt-1"
                      name="phoneNumber"
                      value={form.phoneNumber}
                      onChange={handleChange}
                    />
                  </label>
                </div>
                {/* Right Column */}
                <div className="space-y-6">
                  {/* Industry */}
                  <label className="block">
                    <Label>Industry</Label>
                    <Input
                      type="text"
                      className="mt-1"
                      name="industry"
                      value={form.industry}
                      onChange={handleChange}
                    />
                  </label>
                  {/* Title of Message */}
                  <label className="block">
                    <Label>Title of Message</Label>
                    <Input
                      type="text"
                      className="mt-1"
                      name="titleOfMessage"
                      value={form.titleOfMessage}
                      onChange={handleChange}
                    />
                  </label>
                  {/* Message */}
                  <label className="block">
                    <Label>Message</Label>
                    <Textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      className="mt-1"
                      rows={6}
                    />
                  </label>
                </div>
                {/* Submit Button */}
                <div className="sm:col-span-2 flex justify-center">
                  <ButtonPrimary
                    loading={loading}
                    onClick={onClick}
                    type="button"
                  >
                    Send Message
                  </ButtonPrimary>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContactBusiness;
